"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var socketIO = require("socket.io-client");
var Request = require("./_request-api");
var Session = require("./session");
var constants_1 = require("../data/constants");
var call_status_1 = require("../helpers/call-status");
var chatServers = [];
var signInRequiredError = new Error("Signin required");
var ChatServer = (function () {
    function ChatServer(socket, from) {
        this.socket = socket;
        this.from = from;
    }
    ChatServer.prototype.onNewMessage = function (callback) {
        return this.connect("messages:created", callback);
    };
    ChatServer.prototype.onMessageRead = function (callback) {
        return this.connect("messages:read", callback);
    };
    ChatServer.prototype.onMessageReceived = function (callback) {
        return this.connect("messages:received", callback);
    };
    ChatServer.prototype.onMessageUpdate = function (callback) {
        return this.connect("messages:updated", callback);
    };
    ChatServer.prototype.onNewConversation = function (callback) {
        var _this = this;
        return this.connect("conversations:update", function (conversation) { return callback(Object.assign({}, conversation, {
            with: conversation.from._id === _this.from ? conversation.to : conversation.from
        })); });
    };
    ChatServer.prototype.onCallUpdate = function (callback) {
        return this.connect("call:updated", function (call) { return callback(call_status_1.CallWithStatus(call)); });
    };
    ChatServer.prototype.markAsReceived = function (id) {
        return Request.sendPut(constants_1.endpoints.chat + "/messages/" + id, {
            user: this.from,
            receivedAt: new Date(),
        });
    };
    ChatServer.prototype.markAsRead = function (ids) {
        return Request.sendPost(constants_1.endpoints.chat + "/read", {
            ids: ids,
            user: this.from,
            readAt: new Date(),
        });
    };
    ChatServer.prototype.send = function (message, to, data) {
        if (data === void 0) { data = null; }
        if (!message || message.trim() === "") {
            return Promise.reject({ message: "empty" });
        }
        if (!to) {
            return Promise.reject({ to: "empty" });
        }
        return Request.sendPost(constants_1.endpoints.chat + "/messages", {
            from: this.from,
            to: to,
            content: message,
            sentAt: new Date(),
            data: JSON.stringify(data)
        });
    };
    ChatServer.prototype.conversations = function (page) {
        var _this = this;
        if (page === void 0) { page = 1; }
        return Request.sendGet(constants_1.endpoints.chat + "/users/" + this.from + "/conversations", {
            page: page,
        })
            .then(function (conversations) { return conversations.map(function (conversation) { return Object.assign({}, conversation, {
            with: conversation.from._id === _this.from ? conversation.to : conversation.from
        }); }); });
    };
    ChatServer.prototype.messages = function (conversationId, page) {
        if (page === void 0) { page = 1; }
        if (!conversationId) {
            return Promise.resolve([]);
        }
        return Request.sendGet(constants_1.endpoints.chat + "/conversations/" + conversationId + "/messages", {
            page: page,
        });
    };
    ;
    ChatServer.prototype.conversation = function () {
        console.warn("this method is deprecated, please use conversationWith instead");
        return Request.sendPost(constants_1.endpoints.chat + "/conversations/search", {
            userId: this.from,
        });
    };
    ;
    ChatServer.prototype.conversationWith = function (userId) {
        var _this = this;
        return Request.sendPost(constants_1.endpoints.chat + "/conversations/search", {
            from: userId,
            to: this.from
        })
            .then(function (conversation) { return Object.assign({}, conversation, {
            with: conversation.from._id === _this.from ? conversation.to : conversation.from
        }); })
            .catch(function () { return ({
            from: { _id: _this.from },
            to: { _id: userId },
            with: { _id: userId }
        }); });
    };
    ;
    ChatServer.prototype.connect = function (eventName, callback) {
        this.socket.on(eventName, callback);
        return this;
    };
    return ChatServer;
}());
exports.ChatServer = ChatServer;
var getChat = function (from) {
    if (!Session.signedIn()) {
        throw signInRequiredError;
    }
    return new Promise(function (resolve, reject) {
        var chatServer = chatServers.find(function (e) { return e.from === from; });
        if (chatServer) {
            return resolve(chatServer);
        }
        var socket = socketIO(constants_1.endpoints.chat, {
            transports: ["websocket"],
            query: [
                "user",
                from,
            ].join("="),
        });
        socket.on("disconnect", function () {
            var index = chatServers.findIndex(function (e) { return e.from === from; });
            if (index >= 0) {
                delete chatServers[index];
                chatServers.splice(index, 1);
            }
        });
        socket.on("connect", function () {
            var chatServer = new ChatServer(socket, from);
            chatServers.push(chatServer);
            resolve(chatServer);
        });
        socket.on("error", reject);
        return socket;
    });
};
exports.getChat = getChat;
var pendingMessages = function (user) {
    return Request.sendGet(constants_1.endpoints.chat + "/pendings", {
        user: user,
    });
};
exports.pendingMessages = pendingMessages;
//# sourceMappingURL=chat.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/modules/chat.js
// module id = 904
// module chunks = 3